<template>
    <section>
        <div class="shadow-box section-content" :class="{'with-shadow' : !$mq.isDesktop()}">
            <h2>News</h2>
            <div class="label" v-if="!loading && alert">{{ alert }}</div>
            <loading-placeholder v-if="loading" />
        </div>
    </section>
</template>

<script>

import { menuStore } from '../../store/menuStore' 

export default {
    data () {
      return {
        menuStore: menuStore.state
      }
    },

    computed: {
      menu () {
        return this.menuStore.menu
      },
      loading () {
          return !this.menu
      },
      alert () {
          return this.menu && this.menu.alert && this.menu.alert.message || 'Scopri la selezione delle nostre Colazioni, dei Pranzi e gli Sfizi di qualità certificata e completa la tua spesa su Quomi!'
      }
    },

    mounted () {
      menuStore.loadCurrentMenu()
    }
}

</script>

<style scoped>
.shadow-box {
  position: relative;
  padding: 10px;
  height: 100%;
}

.label {
}

h3 {
  line-height: 1.8;
  font-size: 23px;
  padding: 0px;
}

@media (max-width: 1024px) {
  h3 {
    font-size: 20px;
  }
}

</style>
